import React, { useState } from 'react'
import BreakoutContentCard, { BreakoutContentRow } from '../BreakoutContent';
import styled from 'styled-components';
import { createMarkup } from '../../util/functions';
import { Heading, Text } from '../../util/typography';
import * as CTA from '../../util/CTA';
import * as colors from '../.././util/colors';
import { arrowRightWhite } from '../../util/icons';
import { splitGradient } from '../../util/CTA/PrimaryButton';
import { multiTextUnderline } from '../../util/typography/Text';

const FootLinkContainer = styled.div`
padding-top: 15px; 
text-align: ${({ shouldCenter }) => (shouldCenter ? 'center' : 'left')};
`;
const LinkContainer = styled.div`
.noBreak {
white-space: nowrap;
}
`;

export const StyledTertiaryButton = styled(CTA.TertiaryButton)`
display:  ${({ shouldCenter }) => (shouldCenter ? 'inline-flex' : 'inline')} !important;
background-image: none !important;
> span {
padding: ${({ shouldCenter }) => !shouldCenter ? '0' : '0.9em 0'} !important;
${multiTextUnderline}; 
background-image: ${({ shouldCenter }) => (shouldCenter ? 'none' : 'inline')} !important;
}
&:hover {
span {
&::before
    {transform:  ${({ shouldCenter }) => (shouldCenter ? 'scaleX(1)' : 'scaleX(0)')};}
    }
}
&::after {
display: ${({ shouldCenter }) => (!shouldCenter && 'none')}}
`;

const TertiaryButtonContainer = styled.div`
display: ${({ shouldCenter }) => shouldCenter ? 'block' : 'flex'};
align-items: center;
justify-content: space-between;
cursor: pointer;
padding: ${({ shouldCenter }) => shouldCenter ? '0' : '0.9em 0'} !important;
&::after {
    flex: 0 0 20px;
    display: ${({ shouldCenter }) => shouldCenter ? 'none' : 'inline-block'}; ;
    content: '';
    background-image: url(${arrowRightWhite}), ${splitGradient(colors.blueberry, colors.blueberry)};
    background-repeat: no-repeat;
    background-position: center, left;
    background-size: 10px 10px, 200% 100%;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    margin-left: 6px;
    }
&:hover {
        ${StyledTertiaryButton}{
        color: ${colors.blueberryDark};
> span{
        background-size: 100% 1.1px !important;
        }
        }
&::after {
            animation-name: arrowRight-animation;
            animation-duration: .3s;
            animation-name: arrowRight-animation;
            animation-fill-mode: both;
            background-image: url(${arrowRightWhite}), ${splitGradient(colors.blueberry, colors.blueberryDark)};
        }
    }

    @keyframes arrowRight-animation {
        0% {
            background-position: center 50%, left;
        }
        50% {
            background-position: calc(100% + 20px) center, center;
        }
        50.001% {
            background-position: calc(0% - 20px) center, center;
        }
        100% {
            background-position: center 50%, right;
        }
    }
`;

const StyledDivider = styled.div`
border-top: 1px solid #BEBEBE;
margin-top: 15px;
padding-top: 15px;
`;

const CardHead = styled(Heading.H4)`
display:block;
text-align: ${({ shouldCenter }) => (shouldCenter ? 'center' : 'left')};
* + & {
margin-bottom: 6px;
}
`;
const CardContent = styled(Text.Body)`
display:block;
text-align: ${({ shouldCenter }) => (shouldCenter ? 'center' : 'left')};
* + & {
margin-top: 6px;
}`;

const EarlierStageGrid = (props) => {
    const [isEarlyCardHovered, setisEarlyCardHovered] = useState(false);

    return (
        <BreakoutContentCard
            icon={() => <img src={props.img}
                alt=""
                width={60}
                height={60} />}
            columns={3}
            card={props.card}
            isClickable={props.isClickable}
            url={props.isClickable ? props.keynote[0].url : ''}
            setisEarlyCardHovered={setisEarlyCardHovered}
            linkButton={props.linkButton}
        >
            <div>
                <CardHead as='H4' dangerouslySetInnerHTML={createMarkup(`${props.head}`)} shouldCenter={props.shouldCenter} />
                <Text.Eyebrow>{props.subHead}</Text.Eyebrow>
                <CardContent shouldCenter={props.shouldCenter}>{props.content}</CardContent>
            </div>
            <FootLinkContainer shouldCenter={props.shouldCenter}>
                {props.keynote.map((keynoteItem, index) => (<LinkContainer >
                    {index === 2 && <StyledDivider />}
                    <TertiaryButtonContainer shouldCenter={props.shouldCenter}>
                        <StyledTertiaryButton url={keynoteItem.url} label={keynoteItem.label} parentHovered={props.isClickable && isEarlyCardHovered} shouldCenter={props.shouldCenter} />
                    </TertiaryButtonContainer>
                </LinkContainer>))}
            </FootLinkContainer>
        </BreakoutContentCard>
    )
}
export default EarlierStageGrid;